/**
 * Etiquetas que el contrato no trae.
 *
 * `@ops/contracts` exporta ROLE_LABELS, SOURCE_LABELS, CLIENT_STATE_LABELS y
 * varias más, pero no tiene nombre legible para `Unit` ni para `direccion`, y el
 * catálogo de métricas los muestra en dos columnas. Quedan acá y no inventados en
 * el JSX para que la tabla, el formulario y el texto de los umbrales digan
 * exactamente lo mismo.
 */
import type { Unit } from '@ops/contracts'

export const UNIDAD_LABELS: Record<Unit, string> = {
  usd: 'dólares',
  percent: 'porcentaje',
  count: 'cantidad',
  months: 'meses',
  ratio: 'ratio',
  position: 'posición',
}

export type Direccion = 'higher_better' | 'lower_better'

export const DIRECCION_LABELS: Record<Direccion, string> = {
  higher_better: 'más es mejor',
  lower_better: 'menos es mejor',
}

/**
 * Operador del umbral según la dirección: un umbral de 75.000 en MRR se cumple
 * con ≥ y uno de 5% en churn con ≤. Escribir solo el número deja al lector
 * adivinando de qué lado está el verde.
 */
export const DIRECCION_OPERADOR: Record<Direccion, string> = {
  higher_better: '≥',
  lower_better: '≤',
}
